export default __webpack_public_path__ + "static/media/btn-zeroback-stop-be_dt@2x.89a10815.png";